import { toast } from "react-toastify";
import { LOGIN, LOGOTUT } from "../../../helper/url_helper";

import { axiosApi } from "../../../services/api";
import { set } from "../../../services/cookies";

import { createAsyncThunk } from "@reduxjs/toolkit";

// export const handleLogin = createAsyncThunk(
//   "auth/handleLogin",
//   async (request) => {
//     try {
//       const res = await axiosApi.post(LOGIN, request);
//       if (res.data?.statusCode === 200 && res?.data?.data?.access_token) {
//         set("token", res?.data?.data?.access_token);
//         // request?.navigate("/");
//         toast.success(res?.data?.message);

//         return res.data?.data; // serializable
//       }
//       if (res?.data?.statusCode === 401) {
//         toast.error("Invalid email or password");
//       }
//     } catch (err) {
//       const message =
//         err?.response?.data?.message ||
//         err?.response?.data?.errors?.[0]?.message ||
//         "Login failed";

//       toast.error(message);

//       return {
//         error: message,
//         statusCode: err?.response?.status || 500,
//       };
//     }

//   }
// );





export const handleLogin = createAsyncThunk(
  "auth/handleLogin",
  async (request, { rejectWithValue }) => {
    try {
      const res = await axiosApi.post(LOGIN, request);

      // success case (200)
      if (res.data.success) {
        set("token", res.data.data.token);
        toast.success(res.data.message);
        return res.data.data;
      }

      // 200 but success=false
      const errorMessage =
        res.data.errors?.[0]?.message ||
        res.data.message ||
        "Login failed";

      toast.error(errorMessage);
      return rejectWithValue(res.data);
    } catch (err) {
      // 4xx / 5xx
      const response = err?.response?.data;

      const message =
        response?.errors?.[0]?.message ||
        response?.message ||
        "Invalid email or password";


      toast.error(message);

      return rejectWithValue({
        message,
        statusCode: err?.response?.status,
      });
    }
  }
);


export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosApi.post(LOGOTUT);
      return res.data;
    } catch (err) {
      return rejectWithValue({
        message: err?.response?.data?.message,
        statusCode: err?.response?.status || 500,
      });
    }
  }
);  